import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import StudentDisplayName from './student-displayname'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../stores/user/user.selectors'
import {
  updateUser,
  generateStudentDisplayName
} from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    displayName: user.display_name
  }
}

const mapDispatchToProps = (dispatch, { refetchMe }) => ({
  onSubmit: values => {
    const data = {
      display_name: values.displayName
    }
    dispatch(updateUser(data))
      .then(refetchMe)
      .catch(errorHandler)
  },
  onClick: () =>
    dispatch(generateStudentDisplayName()).then(resp => resp.data.display_name)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StudentDisplayName)
)
